/* 我的首页 */
<template>
  <div class="my-user-info-box">
    <!-- 头部 -->
    <headerTop :type="0" title="我的"></headerTop>
    <!-- 内容 -->
    <div class="content">
      <div class="user-info">
        <div class="contact">
          <div class="info">
            <p class="phone">
              {{
                userInfo.phone
                  ? userInfo.phone.substring(0, 3) +
                    "****" +
                    userInfo.phone.substring(7, 11)
                  : userInfo.phone
              }}
            </p>
            <div class="role">
              <span class="name">{{ userInfo.realname }}</span>
              <span class="tag">{{ userInfo.user_type_name }}</span>
              <span v-if="userInfo.star_type != 0" class="tag2">{{
                userInfo.star_type
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="classification-box">
        <!-- 钱包 -->
        <div class="pouch">
          <div class="title" @click="goPouch">
            <p>钱包</p>
            <div>
              <span>查看钱包</span>
              <span class="iconfont iconyoujiantou"></span>
            </div>
          </div>
          <div class="balance">
            <span>账户金额</span>
            <span>{{ account.balance }}</span>
          </div>
          <div class="password-bank">
            <div class="password-bank-l" @click="toNewsInspect">
              <span class="iconfont iconzhifumimaguanli"></span>
              <span>支付密码管理</span>
            </div>
            <div class="password-bank-c"></div>
            <div class="password-bank-r" @click="accountBank">
              <span class="iconfont iconyinhangka"></span>
              <span>绑定银行卡</span>
            </div>
          </div>
        </div>
        <div class="menu" @click="toTeamPerformance">
          <div class="title">
            <p>我的业绩</p>
            <div>
              <span class="iconfont iconyoujiantou"></span>
            </div>
          </div>
        </div>
        <div class="menu" @click="toUpdatePassword">
          <div class="title">
            <p>修改登录密码</p>
            <div>
              <span class="iconfont iconyoujiantou"></span>
            </div>
          </div>
        </div>
      </div>
      <!-- 退出登录 -->
      <!-- 2026-10-24 去掉 v-if="isWap"：原条件在微信内置浏览器（UA 含 MicroMessenger）下
           整个节点不渲染，导致微信里没有退出登录入口；与 C 端 agui-h5 行为对齐。 -->
      <div class="go-out">
        <div class="out-btn" @click="logout">退出登录</div>
      </div>
      <div style="height: 5px"></div>
    </div>
    <!-- 返回确认 -->
    <popupConfirm
      :openPopup.sync="popupConfirmStatus"
      content="是否退出登录？"
      @confirmEvent="confirmEvent"
    />
  </div>
</template>

<script>
import headerTop from "@/components/common/headerTop.vue";
import popupConfirm from "@/components/popupcom/popupConfirm.vue";
import javaApi from "@/api/javaApi";
import userApi from "@/api/userApi";
import accountApi from "@/api/accountApi";
import { removeToken, removeUserId } from "@/libs/util";

export default {
  data() {
    return {
      popupConfirmStatus: false,
      userInfo: {},
      account: {},
    };
  },
  components: {
    headerTop,
    popupConfirm,
  },
  created() {},
  mounted() {
    accountApi.accountBank().then((res) => {
      this.$store.commit("setAccountBankObj", res);
    });

    
  },
  activated() {
    // this.userInfo = this.$store.state.userInfo;
    javaApi.accountDetail().then((res) => {
      this.account = res;
    });
    this.refreshUserInfo();
  },
  methods: {
    // 点击进钱包
    goPouch() {
      this.$router.push({
        name: "pouch",
      });
    },
    //拉取一下用户信息
    async refreshUserInfo() {
      let res = await javaApi.userInfo();
      this.$store.commit("setUserObj", {
        phone: res.data.phone,
        realname: res.data.realname,
        user_id: res.data.user_id,
        user_type_name: res.data.user_type_name,
        user_type: res.data.user_type,
        star_type: res.data.star_type,
      });
      this.userInfo = res.data;
    },
    // 绑卡页面
    accountBank() {
      if (this.$store.state.accountBank.id === undefined) {
        this.$router.push({
          name: "bindingCard",
        });
      } else {
        this.$router.push({
          name: "boundCard",
        });
      }
    },
    // 设置支付密码
    toNewsInspect() {
      accountApi.tradePasswordCheck().then((res) => {
        if (res.status == 1) {
          // this.$router.push({
          //   name: "paymentPassword"
          // });
          this.$router.push({
            name: "newsInspect",
            query: { forget: 1 },
          });
        } else {
          this.$router.push({
            name: "newsInspect",
          });
        }
      });
    },
    // 团队业绩
    toTeamPerformance() {
      this.$router.push({
        name: "teamPerformance",
      });
    },
    // 修改登录密码
    toUpdatePassword() {
      this.$router.push({
        name: "updatePassword",
      });
    },
    confirmEvent() {
      userApi.logout().then((res) => {
        removeUserId();
        removeToken();
        this.$store.commit("setAccountBankObj", null);
        window.location.href = window.location.origin + "/";
      });
    },
    logout() {
      this.popupConfirmStatus = true;
    },
  },
};
</script>

<style lang="less" scoped>
.my-user-info-box {
  background: #f8f8f8;

  .content {
    height: calc(100vh - 90px);
    position: relative;
    .user-info {
      width: 100%;
      height: 140px;
      background: #8a3e2f;
      padding: 25px 15px 0 15px;
      & p:nth-child(1) {
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0;
      }
      .contact {
        margin-top: 11px;
        display: flex;
        justify-content: space-between;
        .info {
          height: 54px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          > .phone {
            font-size: 20px;
            color: #fff;
            letter-spacing: 0;
          }

          > .role {
            .name {
              font-size: 16px;
              color: #fff;
              margin-right: 10px;
            }
            .tag {
              min-width: 37px;
              padding: 0 6px;
              height: 18px;
              background: #ffe795;
              border-radius: 100px;
              font-size: 12px;
              color: #6a5200;
              text-align: center;
              line-height: 20px;
              align-self: flex-start;
            }
            .tag2 {
              min-width: 37px;
              padding: 0 6px;
              margin-left: 6px;
              height: 18px;
              background: #ffe795;
              border-radius: 100px;
              font-size: 12px;
              color: #6a5200;
              text-align: center;
              line-height: 20px;
              align-self: flex-start;
            }
          }
        }
      }
    }
    .classification-box {
      margin: -25px 15px 60px;
      .pouch {
        padding: 15px 15px 0 15px;
        background: #ffffff;
        border-radius: 4px;
        width: 345px;
        height: 144px;
        .title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          & p:nth-child(1) {
            font-size: 16px;
            color: #1d1d1d;
            font-weight: 700;
          }
          div {
            font-size: 14px;
            color: #8d8d8d;
            letter-spacing: 0;
            text-align: right;
            display: flex;
            align-items: center;
            .iconyoujiantou {
              font-size: 12px;
              margin-left: 8px;
            }
          }
        }
        .balance {
          display: flex;
          align-items: center;
          margin-top: 18px;
          & span:nth-child(1) {
            font-size: 14px;
            color: #8a3e2f;
            font-weight: 700;
          }
          & span:nth-child(2) {
            font-size: 24px;
            color: #ea2c2c;
            margin-left: 7px;
            font-weight: 700;
          }
        }
        .password-bank {
          border-top: 0.5px solid #e4e4e4;
          height: 50.5px;
          width: 100%;
          background: #ffffff;
          margin-top: 20px;
          display: flex;
          align-items: center;
          .password-bank-l {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            color: #333333;

            & span:nth-child(2) {
              margin-left: 5px;
            }
          }
          .password-bank-c {
            background: #e4e4e4;
            width: 1px;
            height: 30px;
          }
          .password-bank-r {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            color: #333333;
            & span:nth-child(2) {
              margin-left: 5px;
            }
          }
        }
      }
    }
    .menu {
      margin-top: 15px;
      background-color: #fff;
      border-radius: 4px;
      .title {
        height: 50px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 15px;

        & p:nth-child(1) {
          font-size: 16px;
          color: #1d1d1d;
          font-weight: 700;
        }
        div {
          font-size: 14px;
          color: #8d8d8d;
          letter-spacing: 0;
          text-align: right;
          display: flex;
          align-items: center;
          .iconyoujiantou {
            font-size: 12px;
            margin-left: 8px;
          }
        }
      }
    }
    .go-out {
      position: absolute;
      bottom: 30px;
      display: flex;
      justify-content: center;
      width: 100%;
      .out-btn {
        background: #ffffff;
        border-radius: 100px;
        width: 150px;
        height: 40px;
        font-size: 14px;
        color: #8d8d8d;
        text-align: center;
        line-height: 40px;
      }
    }
  }
}
</style>
